import { Injectable } from '@angular/core';
import { CreateSetupParameterKindsEntry, CreateSetupParameterTemplateListValuesEntry,
  CreateSetupParameterTemplatesEntry, DeleteSetupParameterKindsEntry,
  DeleteSetupParameterTemplateListValuesEntry, DeleteSetupParameterTemplatesEntry,
  SetupParameterKindListViewModel, SetupParameterService,
  SetupParameterTemplateListValueListViewModel,
  SetupParameterTemplateListViewModel, SetupParameterType,
  UpdateSetupParameterKindsEntry, UpdateSetupParameterTemplateListValuesEntry,
  UpdateSetupParameterTemplatesEntry } from 'chronos-basedata-client';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SetupParameterDsService {

  constructor(private setupParameterService: SetupParameterService) { }

  //#region SetupParameterTemplate

  public getSetupParameterTemplateList(
      setupParameterTemplateId?: number,
      setupParameterType?: SetupParameterType,
      externalSetupKindUsageId?: string,
      setupParameterKindId?: number
   ): Observable<SetupParameterTemplateListViewModel[]> {

    const param = {
      setupParameterTemplateId,
      setupParameterType,
      externalSetupKindUsageId,
      setupParameterKindId
    };

    return this.setupParameterService.getSetupParameterTemplates(param);
  }

  public getSetupParameterTemplateById(setupParameterTemplateId: number): Observable<SetupParameterTemplateListViewModel> {

    const params = {
      setupParameterTemplateId
    };

    return this.setupParameterService.getSetupParameterTemplateById(params);
  }

  public createSetupParameterTemplate(entry: Array<CreateSetupParameterTemplatesEntry>): Observable<void> {

    const params = {
      body: entry
    };

    return this.setupParameterService.createSetupParameterTemplates(params);
  }

  public updateSetupParameterTemplate(entry: Array<UpdateSetupParameterTemplatesEntry>): Observable<void> {

    const params = {
      body: entry
    };

    return this.setupParameterService.createSetupParameterTemplates(params);
  }

  public deleteSetupParameterTemplate(entry: Array<DeleteSetupParameterTemplatesEntry>): Observable<void> {

    const params = {
      body: entry
    };

    return this.setupParameterService.deleteSetupParameterTemplates(params);
  }

  //#endregion

  //#region SetupParameterKind
  
  public getSetupParameterKinds(
    setupParameterKindId?: number,
    externalSetupParameterKindId?: string,
    workCenterId?: number,
    setupGroupId?: string): Observable<SetupParameterKindListViewModel[]> {
      
    const param = this.initializeSetupData(setupParameterKindId, externalSetupParameterKindId, workCenterId, setupGroupId);

    return this.setupParameterService.getSetupParameterKinds(param);
  }

  public getSetupParameterKindById(
    setupParameterKindId?: number,
    externalSetupParameterKindId?: string,
    workCenterId?: number,
    setupGroupId?: string): Observable<SetupParameterKindListViewModel> {

    const params = this.initializeSetupData(setupParameterKindId, externalSetupParameterKindId, workCenterId, setupGroupId);

    return this.setupParameterService.getSetupParameterKindById(params);
  } 

  public getSetupParameterKindByExternalId(externalSetupParameterKindId: string): Observable<SetupParameterKindListViewModel> {

    const params = {
      externalSetupParameterKindId
    };

    return this.setupParameterService.getSetupParameterKindByExternalId(params);
  }

  public createSetupParameterKinds(entry: Array<CreateSetupParameterKindsEntry>): Observable<void> {

    const params = {
      body: entry
    };
    
    return this.setupParameterService.createSetupParameterKinds(params);
  }

  public updateSetupParameterKinds(entry: Array<UpdateSetupParameterKindsEntry>): Observable<void> {

    const params = {
      body: entry
    };

    return this.setupParameterService.updateSetupParameterKinds(params);
  }

  public deleteSetupParameterKinds(entry: Array<DeleteSetupParameterKindsEntry>): Observable<void> {

    const params = {
      body: entry
    };

    return this.setupParameterService.deleteSetupParameterKinds(params);
  }

  //#endregion

  //#region SetupParameterTemplateListValue

  public getSetupParameterTemplateListValues(setupParameterTemplateListValueId?: number,
    setupParameterTemplateId?: number,
    name?: string):
    Observable<SetupParameterTemplateListValueListViewModel[]> {

    const params = {
      setupParameterTemplateListValueId,
      setupParameterTemplateId,
      name
    };

    return this.setupParameterService.getSetupParameterTemplateListValues(params);
  }

  public getSetupParameterTemplateListValueById(setupParameterTemplateListValueId: number):
    Observable<SetupParameterTemplateListValueListViewModel> {

    const params = {
      setupParameterTemplateListValueId
    };

    return this.setupParameterService.getSetupParameterTemplateListValueById(params);
  }

  public createSetupParameterTemplateListValues(entry: Array<CreateSetupParameterTemplateListValuesEntry>): Observable<void> {

    const params = {
      body: entry
    };

    return this.setupParameterService.createSetupParameterTemplateListValues(params);
  }

  public updateSetupParameterTemplateListValues(entry: Array<UpdateSetupParameterTemplateListValuesEntry>): Observable<void> {

    const params = {
      body: entry
    };

    return this.setupParameterService.updateSetupParameterTemplateListValues(params);
  }

  public deleteSetupParameterTemplateListValues(entry: Array<DeleteSetupParameterTemplateListValuesEntry>): Observable<void> {
    
    const params = {
      body: entry
    };

    return this.setupParameterService.deleteSetupParameterTemplateListValues(params);
  }

  //#endregion 

  private initializeSetupData(setupParameterKindId: number, externalSetupParameterKindId: string,
    workCenterId: number, setupGroupId: string) {
    return {
      setupParameterKindId,
      externalSetupParameterKindId,
      workCenterId,
      setupGroupId
    };
  }

}
